export const CustomTitle = ({ title }) => <h3 className="title">{title}</h3>;
export const CustomDescription = ({ description }) => (
    <p className="description mb-4 pb-4" style={{ borderBottom: "1px solid #ccc" }}>
        <i>{description}</i>
    </p>
);
